import React from "react";

import Box from "../Box";

const Four = props => {
  return (
    <section className="hp__block hp__block--four container">
      <div className="row hp__block__row hp__block__row--first">
        <div className="hp__block__row--xs--first">
          <Box
            {...props}
            id="b1"
            type="news"
            settings={props.settings.b1}
            classes="col-xs-6 col-lg-3"
          />
          <Box
            {...props}
            id="b2"
            type="news"
            settings={props.settings.b2}
            classes="col-xs-6 col-lg-3"
          />
        </div>
        <div className="hp__block__row--xs--second">
          <Box
            {...props}
            id="b3"
            type="news"
            settings={props.settings.b3}
            classes="col-xs-6 col-lg-3"
          />
          <Box
            {...props}
            id="b4"
            type="news"
            settings={props.settings.b4}
            classes="col-xs-6 col-lg-3"
          />
        </div>
      </div>
    </section>
  );
};

export default Four;
